
import { HttpResponse } from "@microsoft/signalr";
import { AwardTypes } from "API/Generated/AwardTypes";
import { Pageant } from "API/Generated/Pageant";
import { PageantAvailableTitle } from "API/Generated/PageantAvailableTitle";
import { RegisteredContestantAwardRelationship } from "API/Generated/RegisteredContestantAwardRelationship";
import { Tabulation } from "API/Generated/Tabulation";


import { AwardTypeBaseModel, PageantAvailableAwardAddEditDTO, PageantAvailableTitleModel, RegisteredContestantAwardRelationshipBaseModel } from "API/Generated/data-contracts";
import { makeObservable, observable, action } from "mobx";
import { makePersistable } from "mobx-persist-store";

class PageantAwardStore {
    PageantAvailabeTitleService: PageantAvailableTitle = new PageantAvailableTitle();
    AwardTypesService: AwardTypes = new AwardTypes();
    RegisteredContestantAwardRelationshipService: RegisteredContestantAwardRelationship = new RegisteredContestantAwardRelationship();
    TabulationService: Tabulation = new Tabulation();
    AwardTypeList: AwardTypeBaseModel[] = [];
    RegisteredContestantAwardRelationships: RegisteredContestantAwardRelationshipBaseModel[] = [];

    ShowModal: boolean = false;
    AllowEdit: boolean = false;
    private isDataLogged: boolean = false;

    constructor(awardTypeList: AwardTypeBaseModel[]) {
        makeObservable(this, {
            AwardTypeList: observable,
            RegisteredContestantAwardRelationships: observable, // Keep this in sync if needed
            ShowModal: observable,
            AllowEdit: observable,
            // updateContestantAwardScore: action,
            // setAwardEligibility: action,
            syncContestantAwards: action,
            setShowModal: action.bound,
            setAllowEdit: action.bound,
        });
        makePersistable(this, {
            name: 'PageantAwardStore',
            properties: ['AwardTypeList', 'ShowModal', 'AllowEdit'],
        });

        this.AwardTypeList = awardTypeList;
    }



    async syncContestantAwards(pageantId: number): Promise<void> {
        try {
            await this.TabulationService.tabulationSyncAwardRelationshipRecordsDynamically({pageantId});
            console.log("Contestant awards synced successfully.");
        } catch (error) {
            console.error("Error syncing contestant awards:", error);
            throw error;
        }
    }

    // Method to sync award relationships for a specific contestant
    // async syncSpecificContestantAwardRelationships(pageantId: number, registeredPageantContestantId: number): Promise<void> {
    //     try {
    //         await this.RegisteredContestantAwardRelationshipService.syncSpecificContestantAwardsCreate(pageantId, registeredPageantContestantId);
    //         console.log("Contestant awards synced successfully.");
    //     } catch (error) {
    //         console.error("Error syncing contestant awards:", error);
    //         throw error;
    //     }
    // }



    async getAwardRelationshipsByPageant(pageantId: number): Promise<any[]> {
        try {
          const response = await this.RegisteredContestantAwardRelationshipService.getAllAwardRelationshipRecordsByPageantId(pageantId);
          const data = await response.json();
    
          // Check if data is valid
          if (!data || !Array.isArray(data) || data.length === 0) {
            console.warn(`No relationships found for pageant ID: ${pageantId}`);
            return [];
          }
    
          // Log only once
          if (!this.isDataLogged) {
          //  console.log('API Response Data:', data);
            this.isDataLogged = true; // Set the flag to true after logging
          }
    
          return data;
        } catch (error) {
          console.error('Error fetching contestant awards relationships:', error);
          throw error;
        }
      }

    async getJustTitleAwardRelationshipsByPageant(pageantId: number): Promise<any[]> {
        try {
            // Make the API call
            const response = await this.RegisteredContestantAwardRelationshipService.getAllAwardRelationshipRecordsByPageantId(pageantId);
            
            // Parse the response data
            const data = await response.json();
    
            // Log the parsed response
         //   console.log("API Response Data:", data);
    
            // Check if the response contains data (array)
            if (!data || !Array.isArray(data) || data.length === 0) {
                console.warn(`No relationships found for pageant ID: ${pageantId}`);
                return [];
            }
    
            // Filter the data to include only those with awardTypeId = 1
            const filteredData = data.filter(item => {
                //console.log("Award Type ID:", item.awardTypeId); // Debugging log
                return item.awardTypeId === 1;
            });
    
            // Log the filtered data
            console.log("Filtered Data (awardTypeId = 1):", filteredData);
    
            // Return the filtered data (array of title relationships)
            return filteredData;
        } catch (error) {
            console.error("Error fetching title award relationships:", error);
            throw error;
        }
    }
    
    async getJustSideAwardRelationshipsByPageant(pageantId: number): Promise<any[]> {
        try {
            // Make the API call
            const response = await this.RegisteredContestantAwardRelationshipService.getAllAwardRelationshipRecordsByPageantId(pageantId);
            
            // Parse the response data
            const data = await response.json();
    
            // Log the parsed response
            console.log("API Response Data:", data);
    
            // Check if the response contains data (array)
            if (!data || !Array.isArray(data) || data.length === 0) {
                console.warn(`No relationships found for pageant ID: ${pageantId}`);
                return [];
            }
    
            // Filter the data to include only those with awardTypeId = 2
            const filteredData = data.filter(item => {
               // console.log("Award Type ID:", item.awardTypeId); // Debugging log
                return item.awardTypeId === 2;
            });
    
            // Log the filtered data
            console.log("Filtered Data (awardTypeId = 2):", filteredData);
    
            // Return the filtered data (array of title relationships)
            return filteredData;
        } catch (error) {
            console.error("Error fetching side award relationships:", error);
            throw error;
        }
    }

    async getJustJackpotAwardRelationshipsByPageant(pageantId: number): Promise<any[]> {
        try {
            // Make the API call
            const response = await this.RegisteredContestantAwardRelationshipService.getAllAwardRelationshipRecordsByPageantId(pageantId);
            
            // Parse the response data
            const data = await response.json();
    
            // Log the parsed response
            console.log("API Response Data:", data);
    
            // Check if the response contains data (array)
            if (!data || !Array.isArray(data) || data.length === 0) {
                console.warn(`No relationships found for pageant ID: ${pageantId}`);
                return [];
            }
    
            // Filter the data to include only those with awardTypeId = 3
            const filteredData = data.filter(item => {
              //  console.log("Award Type ID:", item.awardTypeId); // Debugging log
                return item.awardTypeId === 3;
            });
    
            // Log the filtered data
            console.log("Filtered Data (awardTypeId = 3):", filteredData);
    
            // Return the filtered data (array of title relationships)
            return filteredData;
        } catch (error) {
            console.error("Error fetching jackpot award relationships:", error);
            throw error;
        }
    }

async confirmWinner(awardRelationshipId: number): Promise<any> {
  try {
    const response =
      await this.RegisteredContestantAwardRelationshipService.confirmWinnerUpdate(
        awardRelationshipId,
      );

    console.log("Winner confirmed successfully.", response);

    return response;
  } catch (error) {
    console.error("Error confirming winner:", error);
    throw error;
  }
}

async removeWinner(awardRelationshipId: number): Promise<any> {
  try {
    const response =
      await this.RegisteredContestantAwardRelationshipService.removeWinnerDelete(
        awardRelationshipId,
      );

    console.log("Winner removed successfully.", response);

    return response;
  } catch (error) {
    console.error("Error removed winner:", error);
    throw error;
  }
}

    //--------------------------DTERMINE TITLE WINNERS---------------------
   
    async determineWinnersCreate(pageantId: number): Promise<any[]> {
        try {
            const response =  await this.RegisteredContestantAwardRelationshipService.determineWinnersCreate(pageantId);
            return (response as any); 
        } catch (error) {
            console.error("Error determining winners:", error);
            throw error;
        }
    }
    
    

    async getContestantAttributesByPageant(pageantId: number): Promise<any[]> {
        try {
            const response = await this.RegisteredContestantAwardRelationshipService.getContestantCriteriaAttributesByPageantIdNewList({ pageantId });

            // Cast the response to any type to access the properties without errors
            return (response as any).contestantsAttributes; // Use 'any' to avoid type issues
        } catch (error) {
            console.error("Error fetching contestant attributes:", error);
            throw error; // Rethrow the error for the caller to handle
        }
    }

    async updateAwardScore(contestantId: number, titleId: number, score: number): Promise<void> {
        try {
            // Construct the query object
            const query = {
                contestantId,
                titleId,
                score,
            };

            // Call the service method with the query object
            await this.RegisteredContestantAwardRelationshipService.updateAwardScoreUpdate(query);
            console.log(`Award score updated for contestant ID: ${contestantId}, title ID: ${titleId}, score: ${score}`);
        } catch (error) {
            console.error(`Error updating award score for contestant ID: ${contestantId}:`, error);
            throw error; // Rethrow or handle the error as needed
        }
    }


    async updateIsContestantEntered(contestantId: number, titleId: number, isEntered: boolean): Promise<void> {
        try {
            // Construct the query object
            const query = {
                contestantId,
                titleId,
                isEntered,
            };

            // Call the service method with the query object
            await this.RegisteredContestantAwardRelationshipService.updateIsContestantEnteredUpdate(query);
            console.log(`Is Entered updated for contestant ID: ${contestantId}, title ID: ${titleId}, is Entered?: ${isEntered}`);
        } catch (error) {
            console.error(`Error updating Is Entered for contestant ID: ${contestantId}:`, error);
            throw error; // Rethrow or handle the error as needed
        }
    }

    async updateIsContestantEnteredInSingleAwardDynamically(registeredContestantId: number, titleId: number, shouldBeEntered: boolean): Promise<void> {
        try {
            // Construct the query object
            const query = {
                registeredContestantId,
                titleId,
                isEntered: shouldBeEntered // Pass shouldBeEntered as isEntered in the query
            };

            // Call the service method with the updated query object
            await this.RegisteredContestantAwardRelationshipService.updateIsContestantEnteredDynamicallyUpdate(query);
            console.log(`Is Entered updated for contestant ID: ${registeredContestantId}, title ID: ${titleId}, shouldBeEntered: ${shouldBeEntered}`);
        } catch (error) {
            console.error(`Error updating Is Entered for contestant ID: ${registeredContestantId}, title ID: ${titleId}:`, error);
            throw error; // Rethrow or handle the error as needed
        }
    }

    async updateIsContestantEnteredDynamicallyForAllAwards(
        registeredContestantId: number,
        allPageantTitleIds: number[], // This includes ALL titles for the pageant
        selectedTitleIds: number[], // Titles explicitly selected by the contestant
        titleIdsIncludedInSelectedPackages: number[] // Titles included because of selected packages
    ): Promise<void> {
        try {
            // Combine selected titleIds with those from the packages
            const allSelectedAndIncludedTitleIds = [...selectedTitleIds, ...titleIdsIncludedInSelectedPackages];

            // Use a Set to remove duplicates
            const uniqueSelectedTitleIds = new Set(allSelectedAndIncludedTitleIds);

            // Iterate through all the pageant titles to update their isEntered status
            await Promise.all(allPageantTitleIds.map(async (titleId) => {
                const shouldBeEntered = uniqueSelectedTitleIds.has(titleId); // Check if this title is in the selected or included list

                try {
                    console.log(`Updating Is Entered for contestant ID: ${registeredContestantId}, title ID: ${titleId}, shouldBeEntered: ${shouldBeEntered}`);

                    // Call the service method with the correct query object
                    await this.updateIsContestantEnteredInSingleAwardDynamically(registeredContestantId, titleId, shouldBeEntered);

                    console.log(`Is Entered updated successfully for contestant ID: ${registeredContestantId}, title ID: ${titleId}, shouldBeEntered: ${shouldBeEntered}`);
                } catch (error) {
                    console.error(`Error updating Is Entered for contestant ID: ${registeredContestantId}, title ID: ${titleId}:`, error);
                    throw error; // Optionally handle errors for individual title updates
                }
            }));

            console.log("Is Entered status updated for all titles.");
        } catch (error) {
            console.error("Error during the dynamic update process for all titles:", error);
            throw error;
        }
    }

    async syncAndUpdateContestantAwardRelationshipsForAllAwards(
        pageantId: number,
        registeredContestantId: number,
        allPageantTitleIds: number[], // This includes ALL titles for the pageant
        selectedTitleIds: number[], // Titles explicitly selected by the contestant
        titleIdsIncludedInSelectedPackages: number[] // Titles included because of selected packages
    ): Promise<void> {
        try {
            // Step 1: Sync the contestant's award relationships
            await this.TabulationService.tabulationSyncAwardRelationshipRecordsDynamically({pageantId, registeredContestantId});
            console.log("Contestant awards synced successfully.");

            // Step 2: Update Is Entered status for all awards
            await this.updateIsContestantEnteredDynamicallyForAllAwards(
                registeredContestantId,
                allPageantTitleIds,
                selectedTitleIds,
                titleIdsIncludedInSelectedPackages
            );
            console.log("Is Entered status updated for all titles.");
        } catch (error) {
            console.error("Error during sync and update process:", error);
            throw error;
        }
    }

    async updateIsEnteredForAllContestantsAndAwards(
        pageantId: number,
        allPageantTitleIds: number[], // This includes ALL titles for the pageant
        contestants: any[] // List of all contestants
    ): Promise<void> {
        try {
            // Iterate over each contestant
            for (const contestant of contestants) {
                const registeredContestantId = contestant.id;
    
                // Log the contestant being processed
                console.log(`Processing contestant ID: ${registeredContestantId}`);
    
                // Fetch title IDs explicitly selected by this contestant
                const selectedTitleIds = contestant.RegisteredContestantSelectedTitles.map((t) => t.pageantAvailableTitleId);
                console.log(`Selected titles for contestant ID ${registeredContestantId}:`, selectedTitleIds);
    
                // Fetch title IDs included in packages selected by this contestant
                const titleIdsIncludedInSelectedPackages = contestant.RegisteredContestantSelectedPackages.flatMap((pkg) =>
                    pkg.PageantAvailablePackage?.PageantAvailablePackageToPageantAvailableTitles.map((pt) => pt.PageantAvailableTitleId) || []
                );
                console.log(`Titles from packages for contestant ID ${registeredContestantId}:`, titleIdsIncludedInSelectedPackages);
    
                // Combine selected titleIds with those from the packages
                const allSelectedAndIncludedTitleIds = [...selectedTitleIds, ...titleIdsIncludedInSelectedPackages];
    
                // Use a Set to remove duplicates
                const uniqueSelectedTitleIds = new Set(allSelectedAndIncludedTitleIds);
    
                // Iterate through all the pageant titles to update the isEntered status
                await Promise.all(
                    allPageantTitleIds.map(async (titleId) => {
                        const shouldBeEntered = uniqueSelectedTitleIds.has(titleId); // Check if this title is in the selected or included list
    
                        try {
                            console.log(`Updating Is Entered for contestant ID: ${registeredContestantId}, title ID: ${titleId}, shouldBeEntered: ${shouldBeEntered}`);
    
                            // Call the service method to update the isEntered status for this contestant and title
                            await this.updateIsContestantEnteredInSingleAwardDynamically(registeredContestantId, titleId, shouldBeEntered);
    
                            console.log(`Is Entered updated successfully for contestant ID: ${registeredContestantId}, title ID: ${titleId}, shouldBeEntered: ${shouldBeEntered}`);
                        } catch (error) {
                            console.error(`Error updating Is Entered for contestant ID: ${registeredContestantId}, title ID: ${titleId}:`, error);
                        }
                    })
                );
    
                console.log(`Is Entered status updated for all titles for contestant ID: ${registeredContestantId}`);
            }
    
            console.log("Is Entered status updated for all contestants and titles.");
        } catch (error) {
            console.error("Error during the dynamic update process for all contestants and titles:", error);
            throw error;
        }
    }

    async syncAndUpdateAllContestantsAwardRelationshipsForAllAwards(
        pageantId: number,
        registeredContestants: { 
          id: number, 
          RegisteredContestantSelectedTitles: any[], 
          RegisteredContestantSelectedPackages: any[] 
        }[], // Array of all registered contestants
        allPageantTitleIds: number[] // This includes ALL titles for the pageant
    ): Promise<void> {
        try {
            // Iterate over each contestant
            for (const contestant of registeredContestants) {
                const registeredContestantId = contestant.id;
    
                // Fetch title IDs explicitly selected by this contestant
                const selectedTitleIds = contestant.RegisteredContestantSelectedTitles?.map(t => t.pageantAvailableTitleId) || [];
                console.log(`Selected titles for contestant ID ${registeredContestantId}:`, selectedTitleIds);
    
                // Fetch title IDs included in packages selected by this contestant
                const titleIdsIncludedInSelectedPackages = contestant.RegisteredContestantSelectedPackages?.flatMap(pkg =>
                    pkg.PageantAvailablePackage?.PageantAvailablePackageToPageantAvailableTitles?.map(pt => pt.PageantAvailableTitleId) || []
                ) || [];
                console.log(`Titles from packages for contestant ID ${registeredContestantId}:`, titleIdsIncludedInSelectedPackages);
    
                try {
                    // Sync and update the contestant's award relationships
                    await this.syncAndUpdateContestantAwardRelationshipsForAllAwards(
                        pageantId,
                        registeredContestantId,
                        allPageantTitleIds,    // All available title IDs for the pageant
                        selectedTitleIds,      // Titles explicitly selected by the contestant
                        titleIdsIncludedInSelectedPackages  // Titles included because of selected packages
                    );
    
                    console.log(`Successfully synced and updated contestant ID ${registeredContestantId}`);
                } catch (error) {
                    console.error(`Error syncing and updating contestant ID ${registeredContestantId}:`, error);
                }
            }
    
            console.log("All contestants' award relationships synced and updated successfully.");
        } catch (error) {
            console.error("Error during sync and update for all contestants:", error);
            throw error;
        }
    }

    // async syncAndUpdateAllContestantsAwardRelationshipsForAllAwardsNew(
    //     pageantId: number,
    //     registeredContestants: {
    //         id: number,
    //         RegisteredContestantSelectedTitles: any[],
    //         RegisteredContestantSelectedPackages: any[],
    //         IsInterestedInEvent: boolean,
    //         isDropOut: boolean
    //     }[], // Array of all registered contestants
    //     allPageantTitleIds: number[] // This includes ALL titles for the pageant
    // ): Promise<void> {
    //     try {
    //         // Iterate over each contestant
    //         for (const contestant of registeredContestants) {
    //             const registeredContestantId = contestant.id;
    
    //             // Skip contestants that are isInterested or isDropped
    //             if (contestant.IsInterestedInEvent || contestant.isDropOut) {
    //                 console.log(`Skipping contestant ID ${registeredContestantId} as they are isInterested or isDropped.`);
    //                 continue;
    //             }
    
    //             // Fetch title IDs explicitly selected by this contestant
    //             const selectedTitleIds = contestant.RegisteredContestantSelectedTitles?.map(t => t.pageantAvailableTitleId) || [];
    //             console.log(`Selected titles for contestant ID ${registeredContestantId}:`, selectedTitleIds);
    
    //             // Fetch title IDs included in packages selected by this contestant
    //             const titleIdsIncludedInSelectedPackages = contestant.RegisteredContestantSelectedPackages?.flatMap(pkg =>
    //                 pkg.PageantAvailablePackage?.PageantAvailablePackageToPageantAvailableTitles?.map(pt => pt.PageantAvailableTitleId) || []
    //             ) || [];
    //             console.log(`Titles from packages for contestant ID ${registeredContestantId}:`, titleIdsIncludedInSelectedPackages);
    
    //             try {
    //                 // Sync the contestant's award relationships
    //                  await this.TabulationService.tabulationSyncAwardRelationshipRecordsDynamically({pageantId, registeredContestantId});
    
    //                 // Combine selected titleIds with those from the packages
    //                 const allSelectedAndIncludedTitleIds = [...selectedTitleIds, ...titleIdsIncludedInSelectedPackages];
    //                 const uniqueSelectedTitleIds = new Set(allSelectedAndIncludedTitleIds);
    
    //                 for (const titleId of allPageantTitleIds) {
    //                     const shouldBeEntered = uniqueSelectedTitleIds.has(titleId);
    
    //                     try {
    //                         // Update `isEntered`
    //                         await this.updateIsContestantEnteredInSingleAwardDynamically(registeredContestantId, titleId, shouldBeEntered);
    //                         console.log(`Updated isEntered for contestant ID ${registeredContestantId}, title ID ${titleId}`);
    
    //                         // Update `meetsCriteria`
    //                         await this.updateMeetsContestantCriteria(registeredContestantId, titleId);
    //                         console.log(`Updated meetsCriteria for contestant ID ${registeredContestantId}, title ID ${titleId}`);
    //                     } catch (updateError) {
    //                         console.error(`Error updating criteria or entered status for contestantId: ${registeredContestantId}, titleId: ${titleId}`, updateError);
    //                     }
    //                 }
    
    //                 console.log(`Successfully synced and updated contestant ID ${registeredContestantId}`);
    //             } catch (syncError) {
    //                 console.error(`Error syncing and updating contestant ID ${registeredContestantId}:`, syncError);
    //             }
    //         }
    
    //         console.log("All contestants' award relationships synced and updated successfully.");
    //     } catch (error) {
    //         console.error("Error during sync and update for all contestants:", error);
    //         throw error;
    //     }
    // }

    // async updateMeetsCriteriaAndIsEnteredForAllAwardsInPageant(pageantId: number): Promise<void> {
    //     try {
    //         if (!pageantId || pageantId <= 0) {
    //             console.error("Invalid pageant ID.");
    //             return;
    //         }
    
    //         console.log(`Updating MeetsCriteria and IsEntered for Pageant ID: ${pageantId}...`);
    
    //         // ✅ Fix: Call API and assume success unless it throws an error
    //         await this.RegisteredContestantAwardRelationshipService.updateMeetsCriteriaAndIsEnteredForAllAwardsInPageantUpdate({ pageantId });
    
    //         console.log(`Successfully updated award relationships for Pageant ID: ${pageantId}.`);
    //     } catch (error) {
    //         console.error("Error updating MeetsCriteria and IsEntered:", error);
    //         throw error; // Allow UI to handle errors
    //     }
    // }
    
    
    
    
    
    // async updateMeetsContestantCriteria(contestantId: number, titleId: number): Promise<void> {
    //     try {
    //         // Construct the query for the API call
    //         const query = { contestantId, titleId };
    
    //         // Call the service method to update meetsCriteria status
    //        await this.RegisteredContestantAwardRelationshipService.updateMeetsContestantCriteriaUpdate(query);
    
    //         // Log the success
    //         console.log(`Meets Criteria updated for contestant ID: ${contestantId}, title ID: ${titleId}`);
    //     } catch (error) {
    //         // Handle error in updating
    //         console.error(`Error updating Meets Criteria for contestant ID: ${contestantId}, title ID: ${titleId}`, error);
    //         throw error; // Rethrow or handle the error as needed
    //     }
    // }

  
    

    async updateIsContestantEnteredToAward(registeredContestantId: number, titleId: number): Promise<void> {
        try {
            // Construct the query object
            const query = {
                registeredContestantId,
                titleId,
            };

            // Call the service method with the updated query object
            await this.RegisteredContestantAwardRelationshipService.updateIsContestantEnteredDynamicallyUpdate(query);
            console.log(`Is Entered updated for contestant ID: ${registeredContestantId}, title ID: ${titleId}`);
        } catch (error) {
            console.error(`Error updating Is Entered for contestant ID: ${registeredContestantId}, title ID: ${titleId}:`, error);
            throw error; // Rethrow or handle the error as needed
        }
    }
    

    // Method to update a single contestant's award score
    async updateContestantAwardScore(contestantId: number, titleId: number, score: number): Promise<void> {
        try {
            await this.RegisteredContestantAwardRelationshipService.updateAwardScoreUpdate({
                contestantId,
                titleId,
                score // This will be the titleScore passed from the UI
            });
            console.log("Contestant award score updated successfully.");
        } catch (error) {
            console.error("Error updating contestant award score:", error);
            throw error;
        }
    }

    async getAwardTypes() {
        try {
            const awardTypeResult = await this.AwardTypesService.getAllAwardTypes();
            if (awardTypeResult.data.data) {
                this.AwardTypeList = awardTypeResult.data.data;
            }
        } catch (error) {
            console.error("Error fetching award types:", error);
        }
    }

    async saveAward(model: PageantAvailableTitleModel): Promise<PageantAvailableTitleModel | null> {
        try {
            const awardResult = await this.PageantAvailabeTitleService.savePageantAvailableTitle(model);
            if (awardResult.data.data) {
                return awardResult.data.data;
            }
            return null;
        } catch (error) {
            console.error("Error saving award:", error);
            return null;
        }
    }



    async saveAwards(models: PageantAvailableTitleModel[]): Promise<void> {
        try {
            // Validate that models array is not empty and has valid pageantId
            if (!models || models.length === 0) {
                throw new Error("No awards provided to save.");
            }
    
            const pageantId = models[0]?.pageantId;
            if (!pageantId) {
                throw new Error("Pageant ID is required to save awards.");
            }
    
            // Transform and validate the payload
            const payload = models.map((model) => {
                if (!model.id) {
                    throw new Error("Each award must have a valid ID.");
                }
                return {
                    id: model.id,
                    name: model.name || "Unnamed Title",
                    pullOrder: model.pullOrder || 0, // Default to 0 if not provided
                    awardType: {
                        id: model.awardType?.id || 0,
                        name: model.awardType?.name || '',
                    },
                    description: model.description || "",
                    otherPrizeDescription: model.otherPrizeDescription || "",
                    pageantId: model.pageantId,
                };
            });
    
            // Log the payload for debugging
            console.log("Payload to save:", JSON.stringify(payload, null, 2));
    
            // Call the service method to save the awards
            await this.PageantAvailabeTitleService.saveAllCreate(pageantId, payload);
    
            console.log("Awards saved successfully.");
        } catch (error) {
            // Log the error and rethrow for higher-level handling
            console.error("Error saving awards:", error);
            throw new Error("Failed to save awards. Please try again.");
        }
    }
    
    
    async updatePageantTitleFields(titleId: number, fieldsToUpdate: Record<string, unknown>): Promise<boolean> {
        try {
            // Validate the pageant title ID
            if (!Number.isInteger(titleId) || titleId <= 0) {
                throw new Error("Invalid pageant title ID. It must be a positive integer.");
            }
    
            // Validate the fields to update
            if (
                !fieldsToUpdate ||
                Object.keys(fieldsToUpdate).length === 0 ||
                !Object.entries(fieldsToUpdate).every(([key, value]) => typeof key === "string" && value !== undefined)
            ) {
                throw new Error("Invalid fields provided to update. Ensure all field names are strings and values are defined.");
            }
    
            // Log the payload for debugging
            console.log("Updating pageant title fields:", { titleId, fieldsToUpdate });
    
            // Construct the payload
            const payload = {
                titleId,
                fieldsToUpdate,
            };
    
            // Call the API method from PageantAvailableTitle
            const response = await this.PageantAvailabeTitleService.updatePageantAvailableTitleFields(payload);
    
            // Since response.data is void, check the response status or simply assume success
            if (!response || response.status !== 200) {
                throw new Error("Failed to update title fields. API response did not indicate success.");
            }
    
            // Return true for successful updates
            return true;
        } catch (error) {
            console.error("Error while updating title fields:", error);
            throw new Error(`Failed to update title fields for ID: ${titleId}. ${error}`);
        }
    }
    
    
    
    //#================================= New ADD, UPDATE, REMOVE Award START - testing==================================
// import { PageantAvailableTitleAddEditDTO, PageantAvailableTitleModel } from 'API/Generated/data-contracts';

async addAward(pageantId: number, dto: PageantAvailableAwardAddEditDTO) {
  try {
    const res = await this.PageantAvailabeTitleService.addPageantAvailableAward(pageantId, dto);
    // API returns { data: PageantAvailableTitleModel }
    return res?.data?.data ?? null as (PageantAvailableTitleModel | null);
  } catch (error) {
    console.error('addAwardV2 error', error);
    return null;
  }
}

async updateAward(
  pageantId: number,
  titleId: number,
  dto: PageantAvailableAwardAddEditDTO,
  replacePackages = true
) {
  try {
    // IMPORTANT: pass replacePackages as an object so TS matches the signature
    const res = await this.PageantAvailabeTitleService.updatePageantAvailableAward(
      pageantId,
      titleId,
      dto,
      { replacePackages }
    );
    return res?.data?.data ?? null as (PageantAvailableTitleModel | null);
  } catch (error) {
    console.error('updateAwardV2 error', error);
    return null;
  }
}

async removeAwardAndCorrespondingPackagesAndContestants(
  pageantId: number,
  titleId: number
): Promise<boolean> {
 try {
      console.log("deleting Award", titleId);
      var awardResult = await this.PageantAvailabeTitleService.deletePageantAvailableAward(pageantId, titleId);
      if (awardResult) {
        return true;
      }
      return false;
    } catch (error) {
      console.log("Error: " + JSON.stringify(error));
      return false;
    }
}


    //#================================= New ADD, UPDATE, REMOVE Award END - testing==================================

    
    

    async getAward(id: number): Promise<any> {
        try {
            console.log("Get Award:", id);
            const awardResult = await this.PageantAvailabeTitleService.getPageantAvailableTitleId(id);
            if (awardResult.data) {
                return awardResult.data; // Return the award data
            } else {
                console.warn(`Award with ID ${id} not found.`);
                return null; // Return null if award not found
            }
        } catch (error) {
            console.error("Error getting award:", error);
            return null; // Return null in case of error
        }
    }
    

    async deleteAward(id: number): Promise<boolean> {
        try {
            console.log("Deleting Award:", id);
            const awardResult = await this.PageantAvailabeTitleService.deletePageantAvailableTitle(id);
            return awardResult.data.data ? true : false;
        } catch (error) {
            console.error("Error deleting award:", error);
            return false;
        }
    }


    async setShowModal(show: boolean) {
        console.log("Setting Show Modal:", show);
        this.ShowModal = show;
    }

    async setAllowEdit(allow: boolean) {
        this.AllowEdit = allow;
    }
}

let pageantAwardStore: PageantAwardStore;

export function GetPageantAwardStore() {
    if (!pageantAwardStore) {
        pageantAwardStore = new PageantAwardStore([]);
    }
    return pageantAwardStore;
}
